import * as yup from 'yup'

export const formValidationSchema = yup
  .object({
    message: yup.string().required('Campo obligatorio'),
  })
  .required()
